export default __webpack_public_path__ + "static/media/Energia.08fedf3d.png";